var vowels =
  "(A)|(E)|(H)|(I)|(M)|(O)|(TR)|(U)|(a((a)|(e)|(i)|(u))?)|(e(e)?)|(i)|(o((a)|(o))?)|(tR)|(u)";
var consonants =
  "(B(h)?)|(Ch)|(D(h)?)|(J(h)?)|(K(h)?)|(L)|(N)|(Sh)|(T(h)?)|(b(h)?)|(ch)|(d(h)?)|(f)|(g(h)?)|(h)|(j(h)?)|(k(h)?)|(l)|(m)|(n((G)|(Y))?)|(p(h)?)|(r(R)?)|(s(h)?)|(t(h)?)|(v)|(w)|(y)";
var letter_codes = {
  "~a": "&#3205;",
  "~aa": "&#3206;",
  "~A": "&#3206;",
  "~i": "&#3207;",
  "~ee": "&#3208;",
  "~I": "&#3208;",
  "~u": "&#3209;",
  "~oo": "&#3210;",
  "~U": "&#3210;",
  "~e": "&#3214;",
  "~ae": "&#3215;",
  "~E": "&#3215;",
  "~ai": "&#3216;",
  "~o": "&#3218;",
  "~oa": "&#3219;",
  "~O": "&#3219;",
  "~au": "&#3220;",
  "~tR": "&#3211;",
  "~TR": "&#3296;",
  a: "",
  aa: "&#3262;",
  A: "&#3262;",
  i: "&#3263;",
  ee: "&#3264;",
  I: "&#3264;",
  u: "&#3265;",
  oo: "&#3266;",
  U: "&#3266;",
  e: "&#3270;",
  ae: "&#3271;",
  E: "&#3271;",
  ai: "&#3272;",
  o: "&#3274;",
  oa: "&#3275;",
  O: "&#3275;",
  au: "&#3276;",
  tR: "&#3267;",
  TR: "&#3268;",
  k: "&#3221;",
  K: "&#3221;",
  kh: "&#3222;",
  Kh: "&#3222;",
  g: "&#3223;",
  gh: "&#3224;",
  nG: "&#3225;",
  ch: "&#3226;",
  Ch: "&#3227;",
  j: "&#3228;",
  jh: "&#3229;",
  J: "&#3229;",
  Jh: "&#3229;",
  nY: "&#3230;",
  t: "&#3231;",
  T: "&#3232;",
  d: "&#3233;",
  N: "&#3235;",
  th: "&#3236;",
  Th: "&#3237;",
  dh: "&#3238;",
  D: "&#3239;",
  Dh: "&#3239;",
  n: "&#3240;",
  p: "&#3242;",
  ph: "&#3243;",
  b: "&#3244;",
  B: "&#3245;",
  bh: "&#3245;",
  Bh: "&#3245;",
  m: "&#3246;",
  y: "&#3247;",
  r: "&#3248;",
  rR: "&#3249;",
  l: "&#3250;",
  L: "&#3251;",
  v: "&#3253;",
  w: "&#3253;",
  sh: "&#3254;",
  Sh: "&#3255;",
  s: "&#3256;",
  h: "&#3257;",
  f: "&#3294;",
  M: "&#3202;",
  H: "&#3203;",
  "~M": "&#3202;",
  "~H": "&#3203;",
  "*": "&#3277;",
};

function split_word(word) {
  var syllables = new Array(0);
  var vowel_start_p = true;
  while (word.length) {
    let re = new RegExp(vowels);
    var index = word.search(vowels);
    if (index == 0) {
      //the vowel's at the start of word
      var matched = re.exec(word)[0]; //what is it?
      if (vowel_start_p) {
        syllables.push("~" + matched); //one more to the syllables
      } else {
        syllables.push(matched);
      }
      vowel_start_p = true;
      word = word.substring(matched.length);
    } else {
      re = new RegExp(consonants);
      var index = word.search(consonants);
      if (index == 0) {
        var matched = re.exec(word)[0];
        syllables.push(matched);
        vowel_start_p = false;
        word = word.substring(matched.length);

        //look ahead for virama setting
        var next = word.search(vowels);
        if (next != 0 || word.length == 0) syllables.push("*");
      } else {
        syllables.push(word.charAt(0));
        word = word.substring(1);
      }
    }
  }
  return syllables;
}

function match_code(syllable_mcc) {
  var matched = letter_codes[syllable_mcc];

  if (matched != null) return matched;
  return syllable_mcc;
}

function one_word(word_ow) {
  if (!word_ow) return "";
  var syllables_ow = split_word(word_ow);
  var letters_ow = new Array(0);

  for (var i_ow = 0; i_ow < syllables_ow.length; i_ow++) {
    letters_ow.push(match_code(syllables_ow[i_ow]));
  }
  return letters_ow.join("");
}

function many_words(sentence: string): string {
  // Build a regex pattern for vowels and consonants
  const regex = "((" + vowels + ")|(" + consonants + "))+";
  const words: string[] = [];

  while (sentence.length >= 1) {
    // First case: match strings starting with ``
    let re = new RegExp("^``" + regex);
    let match: any = re.exec(sentence);

    if (match !== null) {
      match = match[0];
      words.push("`");
      words.push(one_word(match.substring(2))); // Call one_word for the substring after first 2 chars
      sentence = sentence.substring(match.length);
    } else {
      // Second case: match strings starting with `
      re = new RegExp("^`" + regex);
      match = re.exec(sentence);
      if (match !== null) {
        match = match[0];
        words.push(match.substring(1)); // Exclude the first ` character
        sentence = sentence.substring(match.length);
      } else {
        // Third case: match strings without leading backticks
        re = new RegExp("^" + regex);
        match = re.exec(sentence);
        if (match !== null) {
          match = match[0];
          words.push(one_word(match)); // Call one_word with the matched string
          sentence = sentence.substring(match.length);
        } else {
          // If no match, push the first character of sentence
          words.push(sentence.charAt(0));
          sentence = sentence.substring(1);
        }
      }
    }
  }

  return words.join("");
}
export const convertToKannada = async (inputText: string): Promise<string> => {
  if (!inputText.trim()) return "";

  try {
    const apiUrl = `https://inputtools.google.com/request?itc=kn-t-i0-und&num=1&cp=0&cs=1&ie=utf-8&oe=utf-8&app=test&text=${encodeURIComponent(
      inputText
    )}`;
    const response = await fetch(apiUrl, {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    });
    if (!response.ok) {
      return "";
    }
    const data = await response.json();
    if (data?.[1]?.[0]?.[1]?.length > 0) {
      return data[1][0][1][0];
    } else {
      return "";
    }
  } catch (err) {
    return "";
  }
};
export const convertEnglishToKannada = (englishWord: string | any): string => {
  // Assume that the input contains Unicode entities like "&#1234;" for Kannada characters
  let englishWords = typeof englishWord != 'string'? englishWord?.fieldSubmissionValue?.value : englishWord?.toLowerCase();
  let text_pmw = englishWords?.length && many_words(englishWords) || ""; // Assuming many_words is defined
  let kannadaWords = "";

  while (text_pmw.length > 0) {
    const unicode_chars = /&#[0-9]+;/;
    const match = unicode_chars.exec(text_pmw);

    if (match !== null) {
      const matchedText = match[0];
      const searchIndex = text_pmw.search(unicode_chars);

      // Append text before the Unicode entity to kannadaWords
      kannadaWords += text_pmw.substring(0, searchIndex);

      // Extract the numerical value from the matched Unicode entity (e.g., "&#1234;")
      const unicodeNumber = matchedText.match(/[0-9]+/);
      if (unicodeNumber !== null) {
        const unicodeValue = Number(unicodeNumber[0]);

        // Use String.fromCodePoint to support extended Unicode range
        kannadaWords += String.fromCodePoint(unicodeValue);
      }

      // Update the remaining text by skipping the processed Unicode entity
      text_pmw = text_pmw.substring(searchIndex + matchedText.length);
    } else {
      // No more Unicode entities, append the remaining text
      kannadaWords += text_pmw;
      text_pmw = "";
    }
  }

  // Convert the text to HTML entities for further usage
  let html_txt = "";
  for (let i = 0; i < kannadaWords.length; i++) {
    const unicodeCharacter = kannadaWords.charCodeAt(i);
    switch (unicodeCharacter) {
      case 32: // Space
        html_txt += " ";
        break;
      case 10: // Newline
      case 13: // Carriage return
        html_txt += "<br/>\n";
        break;
      default:
        html_txt += `&#${unicodeCharacter};`;
    }
  }
  return kannadaWords;
};

// export const convertEnglishToKannada = async (
//   englishWord: string
// ): Promise<string> => {
//   return await convertToKannada(englishWord);
// };
